import {Box, Grid, Card, List, ListItem, Button} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useMemo, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import * as allConstants from '../../../../constants/allConstants';
import base_url from '../../../../baseUrls';
import {useJob} from '../../../../contextProviders/jobContext';
import {useEditRecord} from '../../../../hooks/useEditRecord';
import {useSubform} from '../../../../hooks/useSubform';
import {AddRowButton, variants} from '../../../../pieces/addDeleteEquipmentRowButtons';
import FormSubmitButtons from '../../../../pieces/formSubmitButtons';
import CustomFormBlock from '../../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../../pieces/inputs/formInput';
import {NoDataStringWrapper} from '../../../../pieces/noDataStringWrapper';
import Spacer from '../../../../pieces/spacer';
import {CustomTable} from '../../../../pieces/table';
import {globalUseClasses} from '../../../../styles/globalClasses';
import axios from 'axios';
import ApiUtils from '../../../../utils/apiUtils';
import Utils from '../../../../utils/utils';

const JobTags = (props)=> {
  const classes = {...globalUseClasses()};
  //const gotItPopup = useGotIt();
  const user = useSelector(state=>state.user);
  const {job, setJob} = useJob();
  const {INSPECTION_FIELDS, TAG_FIELDS, JOB_FIELDS} = allConstants;

  const [currentTags, setCurrentTags] = useState(job?.[JOB_FIELDS.JOB_TAGS.api_name] || []);
  const [addingTagTo, setAddingTagTo] = useState([]);
  const [tagNames, setTagNames] = useState([]);

  useEffect(()=> {
    setCurrentTags(job?.[JOB_FIELDS.JOB_TAGS.api_name] || []);
  }, [job]);


  const collectionName = useMemo(()=> JOB_FIELDS.JOB_TAGS.api_name, []);

  const validationSchema = useMemo(()=>Yup.object().shape({
    [collectionName]: Yup.array().of(Yup.object().shape({
      [TAG_FIELDS.TAG_NAME.api_name]: Yup.string().required(allConstants.ERROR_MSG.REQUIRED_FIELD).nullable(),
    }))
  }), []);

  const collectionRow = useMemo(()=>{return {
    [TAG_FIELDS.TAG_NAME.api_name]: '',
    [TAG_FIELDS.REMINDER_DATE.api_name]:null,
  };}, []);

  const {getValue, commonFieldProps, fields, formMethods,
    addRowAction, getDeleteRowButton, replace} = useSubform({
    collectionName: collectionName,
    validationSchema: validationSchema,
    subformRow: collectionRow,
    currentResults: [],
    addRowText: 'Add TAG'
  });

  const addTag = () => {
    const addTagTo = [...addingTagTo];
    addTagTo.push('');
    setAddingTagTo(addTagTo);
    addRowAction();
  
  };

  const getTagNames = async () => {

    const authToken =  await ApiUtils.getAccessToken();
    const url = `${base_url.api}tagJobs/`;
    // Offer the tags of the company that owns this job. A prime company admin can reach a
    // sub-account's job, and its tags live under that sub-account, not under the parent.
    // The server rejects a companyId outside the caller's scope, so this can only narrow.
    const companyId = job?.company?.id ?? props.companyId;
    const newItems = await axios.get(url, {params: {companyId: companyId}, headers: {Authorization: authToken}});

    const newTagNames = newItems.data.data.tags.map( (x, index) =>{
      return {name: x.tagName, value: x.tagName};
    });
    setTagNames(newTagNames);

  }
  const  {edit, EditButton, cancelEdit} = useEditRecord( {editText: 'Create Tags', cancelText: 'Close'});


  // const userAllowedToEditInspection = useMemo(()=> {
  //   return NewPermissionGate({
  //     user: user,
  //     elementPermissions: inspectionRules[ELEMENTS_INSPECTIONS.manageInspection],
  //   });
  // }, [user]);

  useEffect(() => {
    if (addingTagTo.length == 0) {
      addTag();

    }
  },[]);

  // Re-fetch once the job (and so its company) resolves, not just on mount.
  useEffect(() => {
    getTagNames();
  },[job?.company?.id]);

  // useEffect(() => {
  //   addTag();
  // },[tagNames]);
  // useEffect(()=> {
    
  //   replace([]);
  //   getTagNames();
 
  // },[edit]);

  // useEffect(()=> {
  //   if(!edit) {
  //     const currentTagsCount = currentTags?.length || 0;
  //     if(addingTagTo.length > currentTagsCount) {
  //       if (currentTagsCount > 0) {
  //         const tags = [...addingTagTo];
  //         tags.splice(currentTagsCount - 1, addingTagTo.length - currentTagsCount);
  //         setAddingTagTo(tags);
  //       } else {
  //         setAddingTagTo([]);
  //       }
  //     }
  //   }
  // }, [edit]);

  const inspectionFormCommonProps = {
    fullWidth: true,
    maxWidth: '100%',
    isEditable: true,
    renderLabel: true,
    viewMode: !edit
  };

  if(Utils.isDevEnv()) {
    window.tagLogs = formMethods;
  }

  const handleSubmitResponse = (result, message, key)=> {
    const toastOptions = {
      toastId: 'job_tag_response',
      autoClose: 1000,
    };
    setAddingTagTo([]);

    if(result.status === 'success') {

      //console.log('result tags');
      //console.log(result?.data);

      const tags = result?.data?.[JOB_FIELDS.JOB_TAGS.api_name];

      try{

        setJob({...job, ...{[allConstants.JOB_FIELDS.JOB_TAGS.api_name]: tags}});
 
      } catch(e) {
        console.log('Error on handling update job tags', e);
      }

      // formMethods.reset(result?.data?.[INSPECTION_FIELDS.INSPECTION.api_name]);
      cancelEdit();
      toast.success(message ? message : 'Job tag updated', toastOptions);
    } else{
      toast.error(`Job tags update error: ${result?.message}`, toastOptions);
    }
  };

  //const gridTemplateColumns = props.isContractor ? '100px 1fr 1.5fr 1.5fr 3fr':'170px 200px 1fr 40px';
  
  const gridTemplateColumns =  '350px 150px 100px';

  const editInspectionForm = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode:'all',
  });


  if(Utils.isDevEnv()) {
    window.editInspection = editInspectionForm;
  }

  const getInspectionValueFor = (field, defaultValue)=> {
    const inspection = job?.[INSPECTION_FIELDS.INSPECTION.api_name];
    return inspection?.[field.api_name] || defaultValue;
  };

  const resolveAllPromises = (promises)=> {
    const errors = [];
    Promise.all(promises).then((results)=> {
      let updateData = {};

      //console.log('new results =>');
      //console.log(results);

      results.forEach((result)=> {
        if(result.status === 'success') {
          updateData = {...updateData, ...result.data};
        }
        else {
          errors.push(result.message);
        }
      });

      //console.log('new update data');
      //console.log(updateData);

      if(Object.keys(updateData).length > 0) {
        handleSubmitResponse({status: 'success', data: updateData}, 'Inspection updated');
      } else {
        handleSubmitResponse({status: 'error', message: errors.join(', ')}, errors.join(', '));
      }

    });
  };

  const onSubmit = async (data)=> {

    //console.log('on submit tag');
    //console.log(data);

    if(props.isContractor) return;
    let promises = [];
    const jobId = job?.[JOB_FIELDS.ID.api_name];
    const addedRows = data?.[collectionName];

    //console.log('add row');
    //console.log(addedRows);

    if(addedRows.length > 0) { 
      addedRows.map(x => {
        Object.keys(x).forEach(key => {
          // Check if the property's value is null
          if (x[key] === null) {
              // Delete the property from the object
              x[key] = '';
          }
        });        
      });

      //console.log('new tags');
      //console.log(addedRows);
      

      promises.push(ApiUtils.makeApiCall('POST', 'jobs/add-job-tags', JSON.stringify({
        id: jobId,
        tags: addedRows,
      })).then(
        (result)=> {return result;}
      ));
    }
    resolveAllPromises(promises);
  };

  const getTagFieldValue = (fieldName, index)=> {
    //if(props.isContractor){
    return job?.[INSPECTION_FIELDS.INSPECTION.api_name]?.[collectionName]?.[index]?.[fieldName];
    //}
    //return returnValue ? returnValue : getValue(fieldName, index);
  };

  const onRowDelete = (index)=> {
    const tags = [...addingTagTo];
    tags.splice(index, 1);
    setAddingTagTo(tags);
  };

  const createTagTableData = ()=> {
    const pastTags = [...currentTags].reverse();

    const header = [
      TAG_FIELDS.TAG_NAME.label,
      TAG_FIELDS.REMINDER_DATE.label,
    ];

    const data = pastTags.map((row)=> {
      return [
        row[TAG_FIELDS.TAG_NAME.api_name],
        Utils.formatIsoDateString(row[TAG_FIELDS.REMINDER_DATE.api_name], {date: true}),
      ];
    });
    const columnWidths = [250, 150, null];
    return {
      tableHeader: header,
      tableData: data,
      columnWidths: columnWidths
    };
  };

  const deleteTagRow = (index)=> {
  
    if(currentTags.length > 0) {

      ApiUtils.makeApiCall('POST', 'jobs/remove-job-tag', JSON.stringify({
        jobId: job?.[JOB_FIELDS.ID.api_name],
        tagId: currentTags[index]._id,
      })).then(
        (result)=> {
        
          setCurrentTags(result.data.tags);
      });
    }
  };

  const editTagRowAction = (index)=> {
    console.log('will edit row', index);
  };
  return(
    <>
        <Box>
            {currentTags && currentTags.length !==0 && <CustomTable tableName={'previous tags'}
              {...createTagTableData()}
              isEditable={true}
              showEditBtn={false} 
              deleteRowAction={deleteTagRow}
            />}
            {!currentTags || currentTags.length ===0 &&
            <NoDataStringWrapper text={'No Tags'}/>
            }
        </Box>
        <Spacer y={1} />
        <Box>
          <Card className={classes.card_block}>
            <Box p={0}>
              <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)}  method="POST">
                  <List>
                    {fields.map((item, index) => (
                      <ListItem key={item.id+index} sx={{
                        paddingX: 0,
                        paddingY: 0,
                        display: 'grid',
                        gridTemplateColumns: gridTemplateColumns,
                        rowGap: '0px',
                        columnGap:'8px',
                        alignItems: 'flex-start',
                        '& .MuiInputBase-inputMultiline': {
                          width: '100% !important',
                        },
                      }}>
                        <CustomFormBlock {...commonFieldProps(index)}
                          showAsStatic={props.isContractor}
                          viewMode={false}
                          isEditable={true}
                          field={TAG_FIELDS.TAG_NAME}
                          //defaultValue={getTagFieldValue(TAG_FIELDS.TAG_NAME.api_name, index)}
                          inputType={inputTypes.singleSelect}                 
                          options={tagNames}  
                        />
                        <CustomFormBlock {...commonFieldProps(index)}
                          inputType={inputTypes.dateNoon}
                          viewMode={false}
                          isEditable={true}
                          labelSecondary={true}
                          field={TAG_FIELDS.REMINDER_DATE}
                          //defaultValue={getTagFieldValue(TAG_FIELDS.REMINDER_DATE.api_name, index)}
                        />
                        {/* {getDeleteRowButton(index, ()=>onRowDelete(index))} */}
                        <Button variant="contained" sx={{minWidth: '80px'}}
                          className={'gray'}
                          color={'primary'}
                          type={'submit'}
                        >Add Tag</Button>   
                     </ListItem>
                    ))}
                  </List>

                </form>
              </FormProvider>
            </Box>
          </Card>
        </Box>
    </>
  );
};

JobTags.propTypes = {
  isContractor: PropTypes.bool,
};

JobTags.defaultProps = {
  isContractor: false,
};

export default JobTags;
